import './Home.css'

const Terms = () => {
    return (
        <div className="home">
            <div className="hero-background"></div>

            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <h1 className="animate-slideUp stagger-1">
                            Terms & <span className="text-gradient">Conditions</span>
                        </h1>
                        <p className="hero-subtitle animate-slideUp stagger-2">
                            Last Updated: December 31, 2025
                        </p>
                    </div>
                </div>
            </section>

            <section className="features">
                <div className="container">
                    <div className="glass-card" style={{ padding: '3rem', marginBottom: '4rem', lineHeight: '1.8' }}>
                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem' }}>1. Agreement to Terms</h2>
                        <p>By accessing or using the NAH44 platform (including NAH44 Tags, Franchise Management, and Recharge services), you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our services.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>2. User Registration</h2>
                        <p>To access certain features, you must register for an account. You agree to provide accurate, current, and complete information during the registration process. You are responsible for safeguarding your password and for any activities or actions under your account.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>3. Service Description</h2>
                        <p>NAH44 provides a vehicle contact system via QR/NFC tags, a franchise management platform for businesses, and a utility recharge service. We reserve the right to modify, suspend, or discontinue any part of the service at any time without notice.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>4. NAH44 Tags & Privacy</h2>
                        <p>Our QR/NFC tags are designed to facilitate communication between vehicle owners and the public. You understand that by using these tags, you are making yourself reachable through our secure platform. Misuse of the system for harassment or illegal activities is strictly prohibited.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>5. Franchise & Business Accounts</h2>
                        <p>Businesses using our Franchise Management system are responsible for the accuracy of their menus, pricing, and order fulfillment. NAH44 acts as the technology provider and is not responsible for the quality of goods or services provided by individual franchises.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>6. Intellectual Property</h2>
                        <p>All content, including logos, graphics, software, and trademarks, is the property of NAH44 Platforms Pvt Ltd and is protected by copyright and intellectual property laws. You may not use our branding without prior written consent.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>7. Prohibited Activities</h2>
                        <p>Users are prohibited from:
                            <ul>
                                <li>Attempting to hack or breach the security of the NAH44 platform.</li>
                                <li>Using the service for fraudulent recharges or payments.</li>
                                <li>Impersonating other users or vehicle owners.</li>
                                <li>Reverse engineering our QR/NFC technology.</li>
                            </ul>
                        </p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>8. Limitation of Liability</h2>
                        <p>To the maximum extent permitted by law, NAH44 shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>9. Governing Law</h2>
                        <p>These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts in Bengaluru, Karnataka.</p>

                        <h2 style={{ color: 'var(--primary-color)', marginBottom: '1.5rem', marginTop: '2.5rem' }}>10. Contact Us</h2>
                        <p>For any questions regarding these Terms, please contact us at legal@nah44.com.</p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Terms
